import { ComponentProps } from 'react';

export const SessionLink = ({
  href,
  children,
  className,
  ...props
}: ComponentProps<'a'> & {
  href: string | undefined;
  children?: React.ReactNode;
}) => {
  if (!href) return null;

  return (
    <a
      href={href}
      rel="noopener noreferrer"
      target="_blank"
      className={`text-black hover:text-gray-700 underline decoration-black hover:decoration-gray-700 ${className || ''}`}
      {...props}
    >
      {children || href}
    </a>
  );
};
